import { render } from "./aboutUsBannerComponent.vue?vue&type=template&id=63ab6f5b&scoped=true"
import script from "./aboutUsBannerComponent.vue?vue&type=script&lang=js"
export * from "./aboutUsBannerComponent.vue?vue&type=script&lang=js"

import "./aboutUsBannerComponent.vue?vue&type=style&index=0&id=63ab6f5b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ab6f5b"]])

export default __exports__